export default {
    validate(value) {
        //console.log("valor: ", value)
        return new RegExp("[a-zA-Z0-9]{1,}$").test(value);        
    }
};